import IconArrowRight from "@/app/(site)/_components/Atoms/Icons/IconArrowRight"
import { MenuItemTypes } from "@/app/(site)/_mockdata/menuItems"
import React from "react"
import DynamicLink from "../Link"

export type MenuItemProps = {
    level: "top" | "second" | "third" | "fourth"
    item?: MenuItemTypes
    light?: boolean
    replaceHistory?: boolean
    [x: string]: any
}

export const MenuItem: React.FC<MenuItemProps> = ({
    level,
    item,
    replaceHistory,
    light = false,
    className,
    ...props
}) => {
    if (!item) return null

    const { uri, title, isNavigationContainer } = item

    const baseClasses =
        "focus:outline-none uppercase flex items-center gap-5 font-trimRegular text-16 md:text-12"
    const clickableClasses = uri ? "group cursor-pointer" : ""
    const combinedClasses = `${baseClasses} ${clickableClasses}`

    const textColor = light
        ? "text-white"
        : level === "third"
          ? "text-main-dark-grey group-hover:text-black"
          : "text-black"

    const hoverTextColor = uri ? "group-hover:text-main-dark-grey" : ""

    const bgColor = light ? "bg-white" : "bg-black"
    const hoverBgColor = uri
        ? light
            ? "group-hover:bg-gray-200"
            : "group-hover:bg-main-dark-grey"
        : ""

    const arrowClasses = `transition-all duration-300 opacity-0 ${
        uri ? "group-hover:opacity-100 group-hover:text-black" : ""
    } w-6 h-6 md:w-20 md:h-12`

    const specialLightSecondStyles =
        light && level === "second" ? "!text-main-white/80" : ""

    const paddingClasses = level === "third" ? "pl-24" : "pl-12"

    const content = (
        <div
            className={`flex items-center gap-x-4 ${className} ${level === "top" ? "mb-16" : ""} ${paddingClasses}`}
        >
            {level === "top" && (
                <div className={`h-12 w-12 md:h-8 md:w-8 ${bgColor} ${hoverBgColor}`} />
            )}
            <span className={`transition-all duration-300 ${hoverTextColor}`}>
                {title}
            </span>
            {!isNavigationContainer && <IconArrowRight className={arrowClasses} />}
        </div>
    )

    const classes = `${combinedClasses} ${textColor} ${specialLightSecondStyles}`

    return isNavigationContainer ? (
        <div className={classes} {...props}>
            {content}
        </div>
    ) : (
        <DynamicLink
            href={uri}
            replace={replaceHistory}
            className={classes}
            prefetch={false}
        >
            {content}
        </DynamicLink>
    )
}
